import map from 'lodash/map'
import omit from 'lodash/omit'
import uniq from 'lodash/uniq'
import type { ListFieldConfig } from '@ztechapps/common.hook'
import type { User } from '@ztechapps/common.contract'
import { collaboratorsQuery, useList } from '@ztechapps/common.hook'
import { useConversationHost } from '../ConversationHost'
import { conversationListFieldConfig } from './constants'

export type UseConversationListFieldConfigResult = ListFieldConfig

// The Assignee column's filter values, loaded at run time from the tenant's internal users —
// modelled on `useProductListFieldConfig` (libs/product/common/src/hooks/useProductListFieldConfig/index.ts).
// `limit: 0` asks `useList` for every collaborator, not the default page. The host's `hiddenInboxColumns` are left out
// of the result, so a column it has no data for neither renders nor shows in the column picker or the search fields.
export const useConversationListFieldConfig = (): UseConversationListFieldConfigResult => {
  const { hiddenInboxColumns } = useConversationHost()
  const collaboratorUserList = useList<User>({
    query: collaboratorsQuery,
    entity: 'getCollaboratorUsers',
    filter: {},
    sort: { 'profile.name': 1 },
    limit: 0,
  })

  const assigneeNames = uniq(map(collaboratorUserList.list, (user) => user.profile?.name))

  return omit(
    {
      ...conversationListFieldConfig,
      assignee: {
        ...conversationListFieldConfig.assignee,
        fieldSettings: { ...conversationListFieldConfig.assignee.fieldSettings, listValues: assigneeNames },
      },
    },
    hiddenInboxColumns ?? []
  )
}
